var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown-item',{attrs:{"command":{ type: 'publishControl', index: _vm.scope.$index, item: _vm.scope.row },"divided":""}},[_vm._v(" "+_vm._s(_vm.scope.row.project.isPublicShow ? "取消公示" : "公示")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }